import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { useFormContext } from 'react-hook-form';
import useNotify from 'hooks/useNotify';
import { PreArrivalFormFields } from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import { InternalCustomDataFieldSubType } from 'models/CustomDataField';
import AddCustomFieldModal from './AddCustomFieldModal';

export const modalId = 'add-custom-field-pre-arrival-form-modal';

const useAddCustomFieldModal = () => {
  const { setValue, getValues } = useFormContext();
  const { notifyError } = useNotify();
  const { openModal, closeModal } = useAppModal();
  const { t } = useTranslation();

  const handleSubmit = (values: any) => {
    const newCustomFields = getValues('newCustomFields') || {};
    // Dots are stripped because RHF interprets them as path separators, so a
    // name like "Custom Field 10.11" would write to the wrong nested location in form state.
    const formattedName = values.name.trim().replace(/\./g, '');
    const key = formattedName.toLowerCase();

    if (newCustomFields[key]) {
      notifyError(
        t('pageAutomations.preArrivalForm.errors.customFieldAlreadyExists'),
      );
      return;
    }

    setValue(
      `newCustomFields[${key}]`,
      {
        id: PreArrivalFormFields.CUSTOM,
        type: values.type,
        // Must use formattedName (not values.name) so the stored value matches
        // the key used in form state and the duplicate check.
        name: formattedName,
        validation: 'REQUIRED',
        subType: InternalCustomDataFieldSubType.OTHER,
        isActive: true,
      },
      {
        shouldDirty: true,
      },
    );

    closeModal(modalId);
  };

  const openAddCustomFieldModal = () => {
    openModal({
      id: modalId,
      title: t('pageAutomations.preArrivalForm.addCustomField'),
      customContent: (
        <AddCustomFieldModal modalId={modalId} handleSubmit={handleSubmit} />
      ),
    });
  };

  return { openAddCustomFieldModal };
};

export default useAddCustomFieldModal;
